import React, { Fragment, useState } from "react";
import { Typeahead } from "react-bootstrap-typeahead";
import DatePicker from "react-datepicker";
import { Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { H6 } from "../../../../AbstractElements";
import { CollegeName, DegreeLevel, Period, Specialization, YourEducation } from "../../../../Constant";

const EducationClass = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [startDate1, setStartDate1] = useState(new Date());

  const handleChange = (date) => {
    setStartDate(date);
  };

  const handleChange1 = (date) => {
    setStartDate1(date);
  };

  return (
    <Fragment>
      <H6 attrH6={{ className: "mb-0" }}>{YourEducation}</H6>
      <Form className="theme-form">
        <Row>
          <Col xl="6" className="xl-100">
            <FormGroup>
              <Label htmlFor="exampleFormControlInput5">
                {CollegeName}:<span className="font-danger">*</span>
              </Label>
              <Input className="form-control" id="exampleFormControlInput5" type="text" placeholder="Enter college name" />
            </FormGroup>
          </Col>
          <Col xl="6" className="xl-100">
            <Label className="col-form-label text-end pt-0">
              {Period}:<span className="font-danger">*</span>
            </Label>
            <Row>
              <Col sm="6">
                <FormGroup>
                  <DatePicker className="form-control" selected={startDate} onChange={handleChange} />
                </FormGroup>
              </Col>
              <Col sm="6">
                <FormGroup>
                  <DatePicker className="form-control" selected={startDate1} onChange={handleChange1} />
                </FormGroup>
              </Col>
            </Row>
          </Col>
          <Col lg="6">
            <div className="col-form-label pt-0">
              {DegreeLevel}:<span className="font-danger">*</span>
            </div>
            <FormGroup>
              <Typeahead id="basic-typeahead" labelKey="name" options={["Student", "Bachelor", "Master", "Associate"]} placeholder="Degree" />
            </FormGroup>
          </Col>
          <Col lg="6">
            <FormGroup>
              <div className="col-form-label pt-0">
                {Specialization}:<span className="font-danger">*</span>
              </div>
              <Input className="form-control" type="text" placeholder="Enter specialization" />
            </FormGroup>
          </Col>
        </Row>
      </Form>
    </Fragment>
  );
};

export default EducationClass;
